import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import NumberField from '../../app-main/components/reduxForms/fields/NumberField/NumberField';
import { DISCOUNT_RATE_FORM } from './constants';
import onSubmitDiscountRateForm from './submit/onSubmitDiscountRateForm';
import validateDiscountRateForm from './validate/validateDiscountRateForm';
import { injectIntl, intlShape } from 'react-intl';

const DiscountRateForm = ({
  handleSubmit = () => {},
  intl
}) => {
  return (
    <Field
      className="DiscountRateInput"
      postInputElements={<span className="input-group-addon" id="discount-rate">%</span>}
      onBlur={handleSubmit(onSubmitDiscountRateForm)}
      component={NumberField}
      name="day_rate_discount.value"
      placeholder={ intl.formatMessage({ id: 'hosting.discount_rate_form.placeholder', defaultMessage: 'Optional' })}
      errorMessage={intl.formatMessage({ id: 'hosting.discount_rate_form.error_message', defaultMessage: 'Please enter a valid rate' })}
    />
  );
};

DiscountRateForm.propTypes = {
  handleSubmit: PropTypes.func,
  intl: intlShape
};

const config = {
  form: DISCOUNT_RATE_FORM,
  validate: validateDiscountRateForm,
  enableReinitialize: true
};

export default reduxForm(config)(injectIntl(DiscountRateForm));
